import React, { useState } from 'react'

import { ReactComponent as PersonIcon } from '../../../../../assets/icons/user-alt-vet.svg'

import NewTutorForm from './NewTutorForm'
import BaseModal from '../BaseModal'

const NewTutorModal = ({ tutorData = undefined, visibility = false, setVisibility = undefined, updated }) => {
  const [isFirstStep, setIsFirstStep] = useState(true)

  return (
    <BaseModal
      visibility={visibility}
      setVisibility={setVisibility}
      icon={<PersonIcon />}
      title={
        tutorData
          ? 'Edição dos dados do tutor'
          : isFirstStep
            ? 'Novo cadastro'
            : 'Novo tutor'
      }
      subTitle={
        tutorData
          ? 'Ao editar os dados e salvar, as informações do tutor serão atualizadas automaticamente.'
          : isFirstStep
            ? 'Para começar, insira o e-mail do tutor'
            : 'Este tutor ainda não possui cadastro por aqui. Por favor, preencha os dados abaixo para continuar e criar uma ficha.'
      }
    >
      <NewTutorForm visibility={visibility} setVisibility={setVisibility} firstStep={[isFirstStep, setIsFirstStep]} tutorData={tutorData} updated={updated} />
    </BaseModal>
  )
}

export default NewTutorModal
